const days = [
    {value: "mandag", text: "Mandag"},
    {value: "tirsdag", text: "Tirsdag"},
    {value: "onsdag", text: "Onsdag"},
    {value: "torsdag", text: "Torsdag"},
    {value: "fredag", text: "Fredag"}
];

export default days;